import { d as dev } from "../../../chunks/index2.js";
const csr = dev;
const prerender = false;
export {
  csr,
  prerender
};
